// extracted by mini-css-extract-plugin
module.exports = {"date":"PeriodPopoutHeader_date__kcdR7"};